<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a><a id="p2"></a><a id="p3"></a>
<div class="copyright">
<p class="center ">Copyright © 2021 by Adam Stern, MD</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="center ">Names: Stern, Adam (Psychiatrist), author.</p>
<p class="center ">Title: Committed : dispatches from a psychiatrist in training / Adam Stern.</p>
<p class="center ">Description: Boston : Houghton Mifflin Harcourt, 2021.</p>
<p class="center ">Identifiers: LCCN 2020057716 (print) | LCCN 2020057717 (ebook) | ISBN 9780358434733 (hardcover) | ISBN 9780358450351 | ISBN 9780358450511 | ISBN 9780358435488 (ebook)</p>
<p class="center ">Subjects: LCSH: Stern, Adam (Psychiatrist) | Harvard Medical School. | Psychiatrists—United States—Biography. | Residents (Medicine)—United States—Biography. | Psychiatry—Study and teaching (Residency)—United States.</p>
<p class="center ">Classification: LCC RC438.6.S75 A3 2021 (print) | LCC RC438.6.S75 (ebook) | DDC 616.89092 [B]—dc23</p>
<p class="center ">LC record available at <a href="https://lccn.loc.gov/2020057716" target="_blank">https://lccn.loc.gov/2020057716</a></p>
<p class="center ">LC ebook record available at <a href="https://lccn.loc.gov/2020057717" target="_blank">https://lccn.loc.gov/2020057717</a></p>
<p class="center spaceabove1">Cover design by Lynn Buckley</p>
<p class="center ">Cover photograph © Roman Sigaev / Shutterstock</p>
<p class="center ">Author photograph © Kate McKenna / Crabapple Photography</p>
<p class="center spaceabove1">v1.0621</p>
<p class="center spaceabove1">Version 04222022KO</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?7c19207c